import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = () => {
  const auth = useAuth();

  // Check if auth context is available
  if (!auth) {
    console.error("Auth context is null in ProtectedRoute. Check Provider setup in index.js.");
    return <Navigate to="/login" replace />;
  }

  const { isAuthenticated, loading } = auth;
  
  if (loading) {
    return <div>Loading...</div>;
  }
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
